import type React from "react";

import { type VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { ButtonType, type SingleSignOnMessages } from "../SingleSignOnComponent";

import { SSOPendingContentComponent } from "./SSOPendingContent";
import { ReclaimPendingContentComponent } from "./ReclaimPendingContent";

interface SingleSignOnProps {
  stepName: VerificationStepsEnum.sso | VerificationStepsEnum.thirdPartyLoop;
  messages: SingleSignOnMessages;
  logo: React.ReactNode;
  cancelSingleSignOn: () => void;
  cancelButtonType?: ButtonType;
  isReclaim?: boolean;
}

const SingleSignOnPending = ({
  stepName,
  messages,
  logo,
  cancelSingleSignOn,
  cancelButtonType = ButtonType.PRIMARY,
  isReclaim = false,
}: SingleSignOnProps) =>
  isReclaim ? (
    <ReclaimPendingContentComponent
      messages={messages}
      stepName={stepName}
      logo={logo}
      cancelSingleSignOn={cancelSingleSignOn}
      cancelButtonType={ButtonType.SECONDARY}
    />
  ) : (
    <SSOPendingContentComponent
      messages={messages}
      stepName={stepName}
      logo={logo}
      cancelSingleSignOn={cancelSingleSignOn}
      cancelButtonType={cancelButtonType}
    />
  );

export const SingleSignOnPendingComponent = SingleSignOnPending;
